"use client";

import React from "react";
export default function GalleryVideoSection() {
  return <section className="bg-[#fbfbf8] px-6 pb-20 text-slate-950 md:px-12 md:pb-24">
      <div className="mx-auto max-w-7xl">
        <div className="overflow-hidden rounded-[40px] border border-slate-200/70 bg-white shadow-[0_18px_46px_rgba(15,23,42,0.06)]">
          <div className="grid grid-cols-1 gap-0 lg:grid-cols-[1.05fr_0.95fr]">
            <div className="flex flex-col justify-center p-8 md:p-10 lg:p-12">
              <div className="mb-5 inline-flex items-center rounded-full border border-slate-200 bg-[#f8faf8] px-4 py-2 text-[11px] font-medium uppercase tracking-[0.22em] text-slate-600 sm:text-xs">
                Видео
              </div>

              <h2 className="mb-5 font-default text-3xl font-bold tracking-[-0.03em] text-slate-950 sm:text-4xl">
                Посмотрите центр <span className="text-[#166534]">в движении</span>
              </h2>

              <p className="max-w-xl font-default text-lg leading-relaxed text-slate-700">
                Короткое видео о том, как проходят занятия и как дети развиваются
                через движение.
              </p>
            </div>

            <div className="p-6 md:p-8 lg:p-10">
              <div className="relative flex min-h-[280px] items-center justify-center overflow-hidden rounded-[32px] border border-slate-200 bg-[#f4f6f2] md:min-h-[360px]">
                <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(22,101,52,0.08),transparent_42%)]" />
                <button type="button" className="relative flex h-20 w-20 items-center justify-center rounded-full border border-white/70 bg-white/90 text-[#166534] shadow-[0_18px_36px_rgba(15,23,42,0.10)] transition-transform duration-300 hover:scale-105" aria-label="Воспроизвести видео">
                  <span className="ml-1 text-2xl"></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}